import React from 'react'
import { Box } from '@material-ui/core'

const ContentfulError = () => {
    return <Box>Encountered error while fetching data from the CMS...</Box>
}

export default ContentfulError